module.exports = __webpack_public_path__ + "img/brands-velo.bd7cd5ad.svg";